/* global axios */
import ApiClient from './ApiClient';

class AppBuilderAPI extends ApiClient {
  constructor() {
    super('apps', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(appData) {
    return axios.post(this.url, { app: appData });
  }

  update(id, appData) {
    return axios.patch(`${this.url}/${id}`, { app: appData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Nested pages: /apps/:appId/pages(/:id)
  getPages(appId) {
    return axios.get(`${this.url}/${appId}/pages`);
  }

  showPage(appId, pageId) {
    return axios.get(`${this.url}/${appId}/pages/${pageId}`);
  }

  createPage(appId, pageData) {
    return axios.post(`${this.url}/${appId}/pages`, { page: pageData });
  }

  updatePage(appId, pageId, pageData) {
    return axios.patch(`${this.url}/${appId}/pages/${pageId}`, {
      page: pageData,
    });
  }

  deletePage(appId, pageId) {
    return axios.delete(`${this.url}/${appId}/pages/${pageId}`);
  }

  // Nested blocks: /apps/:appId/pages/:pageId/blocks(/:id)
  getBlocks(appId, pageId) {
    return axios.get(`${this.url}/${appId}/pages/${pageId}/blocks`);
  }

  createBlock(appId, pageId, blockData) {
    return axios.post(`${this.url}/${appId}/pages/${pageId}/blocks`, {
      block: blockData,
    });
  }

  updateBlock(appId, pageId, blockId, blockData) {
    return axios.patch(
      `${this.url}/${appId}/pages/${pageId}/blocks/${blockId}`,
      { block: blockData }
    );
  }

  deleteBlock(appId, pageId, blockId) {
    return axios.delete(
      `${this.url}/${appId}/pages/${pageId}/blocks/${blockId}`
    );
  }

  // Nested data sources: /apps/:appId/data_sources(/:id)
  getDataSources(appId) {
    return axios.get(`${this.url}/${appId}/data_sources`);
  }

  showDataSource(appId, dataSourceId) {
    return axios.get(`${this.url}/${appId}/data_sources/${dataSourceId}`);
  }

  createDataSource(appId, dataSourceData) {
    return axios.post(`${this.url}/${appId}/data_sources`, {
      data_source: dataSourceData,
    });
  }

  updateDataSource(appId, dataSourceId, dataSourceData) {
    return axios.patch(`${this.url}/${appId}/data_sources/${dataSourceId}`, {
      data_source: dataSourceData,
    });
  }

  deleteDataSource(appId, dataSourceId) {
    return axios.delete(`${this.url}/${appId}/data_sources/${dataSourceId}`);
  }

  // Members (app end-users): /apps/:appId/members(/:id)
  getMembers(appId, params = {}) {
    return axios.get(`${this.url}/${appId}/members`, { params });
  }

  createMember(appId, memberData) {
    return axios.post(`${this.url}/${appId}/members`, { member: memberData });
  }

  updateMember(appId, memberId, memberData) {
    return axios.patch(`${this.url}/${appId}/members/${memberId}`, {
      member: memberData,
    });
  }

  deleteMember(appId, memberId) {
    return axios.delete(`${this.url}/${appId}/members/${memberId}`);
  }

  resendMemberInvite(appId, memberId) {
    return axios.post(`${this.url}/${appId}/members/${memberId}/resend_invite`);
  }

  // Member groups: /apps/:appId/member_groups(/:id)
  getMemberGroups(appId) {
    return axios.get(`${this.url}/${appId}/member_groups`);
  }

  createMemberGroup(appId, groupData) {
    return axios.post(`${this.url}/${appId}/member_groups`, {
      member_group: groupData,
    });
  }

  updateMemberGroup(appId, groupId, groupData) {
    return axios.patch(`${this.url}/${appId}/member_groups/${groupId}`, {
      member_group: groupData,
    });
  }

  deleteMemberGroup(appId, groupId) {
    return axios.delete(`${this.url}/${appId}/member_groups/${groupId}`);
  }

  // Read-only field catalog for the builder binding UI.
  // GET /api/v1/accounts/:account_id/app_metadata?model_name=Ticket
  fetchMetadata(modelName = 'Ticket') {
    return axios.get(`${this.baseUrl()}/app_metadata`, {
      params: { model_name: modelName },
    });
  }
}

export default new AppBuilderAPI();
